const files = require.context('.', false, /\.json$/)
const locale = {}

files.keys().forEach((key) => {
  if (key === './index.js') return
  locale[key.toLowerCase().replace(/(\.\/|\.json)/g, '')] = files(key).map(x => { return { term: x.term, definition: x.definition } })
})

export default locale
